var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.861328,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#AEDF2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.207 9.56904L11.2077 21.5683C11.1148 21.6613 11.0045 21.7351 10.8831 21.7854C10.7617 21.8357 10.6316 21.8616 10.5002 21.8616C10.3688 21.8616 10.2387 21.8357 10.1173 21.7854C9.9959 21.7351 9.88561 21.6613 9.79275 21.5683L4.79304 16.5686C4.60541 16.381 4.5 16.1265 4.5 15.8612C4.5 15.5958 4.60541 15.3413 4.79304 15.1537C4.98067 14.9661 5.23515 14.8607 5.5005 14.8607C5.76585 14.8607 6.02033 14.9661 6.20796 15.1537L10.5002 19.4472L21.792 8.15412C21.9797 7.96649 22.2342 7.86108 22.4995 7.86108C22.7648 7.86108 23.0193 7.96649 23.207 8.15412C23.3946 8.34175 23.5 8.59623 23.5 8.86158C23.5 9.12693 23.3946 9.38141 23.207 9.56904Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.d1e0ad745d3b158c07cb07b25ca35797.svg";
export { ForwardRef as ReactComponent };